import { Box, Button, IconButton, Popover, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useStyles } from './style'
import { PropsModelDownloadButtons } from './typing'
import { MouseEventHandler, useState } from 'react'
import { icons } from '../../utils/icons'

const covertColors = {
  pdf: 'red',
  word: 'blue',
  csv: 'green'
}
const ModelDownloadButtons = (props: PropsModelDownloadButtons) => {
  const { t } = useTranslation()
  const styles = useStyles({ removeMargin: true })
  const [open, setOpen] = useState(false)
  const [anchor, setAnchor] = useState<EventTarget & HTMLButtonElement>()
  const handleDownload: MouseEventHandler<HTMLButtonElement> = (e) => {
    setAnchor(e.currentTarget)
    setOpen(true)
  }
  const closeDownload = () => {
    setOpen(false)
  }
  return (
    <Box sx={styles.container({ styleType: props.styleType ?? false })}>
      {props.extraChildren?.start}

      <Button variant='text_primary' onClick={handleDownload}>{t('general.download')}</Button>

      <Popover
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }} anchorEl={anchor} onClose={closeDownload} open={open}>
        <Box sx={styles.buttons}>
          {!props?.disableTypes?.includes('pdf') && (
            <IconButton
              className='red flex-col'
              disabled={props?.disablePDF}
              onClick={() => {
                props?.pdf()
              }}
            >
              {icons('pdf')}

              <Typography variant='footer' sx={styles.footer}>{props.customeLabels?.pdf ?? t('general.pdf')}</Typography>
            </IconButton>
          )}

          {!props?.disableTypes?.includes('word') && (
            <IconButton
              className='blue flex-col'
              disabled={props?.disableWORD}
              onClick={() => {
                props?.word()
              }}
            >
              {icons('word')}
              <Typography variant='footer' sx={styles.footer}>{props.customeLabels?.word ?? t('general.word')}</Typography>
            </IconButton>
          )}

          {!props?.disableTypes?.includes('excel') && (
            <IconButton
              className='green flex-col'
              disabled={props?.disableCSV}
              onClick={() => {
                props?.csv()
              }}
            >
              {icons('csv')}
              <Typography variant='footer' sx={styles.footer}>{props.customeLabels?.csv ?? t('general.csv')}</Typography>
            </IconButton>
          )}

          {
            !!props?.extraDownload?.length && (
              props.extraDownload.map(download => (
                <IconButton
                  className={`${covertColors[download.type]} flex-col`}
                  disabled={download.disable}
                  onClick={() => {
                    download.dowload()
                  }}
                >
                  {icons(download.type)}
                  <Typography variant='footer' sx={styles.footer}>{t(download.label)}</Typography>
                </IconButton>
              ))
            )
          }
        </Box>
      </Popover>

      {props.extraChildren?.end}
    </Box>

  )
}

export { ModelDownloadButtons }